var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Tooltip } from "@mui/material";
import useWindowWidthDebounced from "./useWindowWidth";
import PropTypes from "prop-types";
const OverFlowTooltip = (_a) => {
    var { children, placement = "bottom-start", title, className = "w-full max-w-full cellMaxWidth", tooltipWidth = "300px" } = _a, rest = __rest(_a, ["children", "placement", "title", "className", "tooltipWidth"]);
    const contentRef = useRef(null);
    const [isOverflowed, setIsOverflowed] = useState(false);
    const width = useWindowWidthDebounced();
    useEffect(() => {
        if (contentRef.current) {
            const el = contentRef.current;
            setIsOverflowed(el.scrollWidth > el.clientWidth);
        }
    }, [children, width]);
    const cellContent = (_jsx("div", Object.assign({ ref: contentRef, className: `truncate ${className}` }, rest, { children: children })));
    return (_jsx(_Fragment, { children: isOverflowed ? (_jsx(Tooltip, { title: title !== null && title !== void 0 ? title : children, placement: placement, componentsProps: {
                tooltip: {
                    sx: {
                        maxWidth: tooltipWidth, //tooltip width
                    },
                },
            }, children: cellContent })) : (cellContent) }));
};
OverFlowTooltip.propTypes = {
    children: PropTypes.node,
};
export default OverFlowTooltip;
